module.exports = __webpack_public_path__ + "static/30-WHY-BRAND-STORYTELLING-IS-KEY-6d45ce62b02e9fade82b179cad708a90.jpg";